import React from 'react'
import { Box, IconButton } from '@mui/material'

import { CloseIcon } from '~assets/icons'

interface BannerProps {
  color?: string
  sx?: React.CSSProperties
  startIcon?: React.ReactNode
  message?: React.ReactNode | string
  dismissable?: boolean
  textAlign?: 'center' | 'left' | 'right'
}

const Banner: React.FC<BannerProps> = ({
  color,
  dismissable,
  startIcon,
  message,
  sx,
  textAlign = 'center',
}) => {
  const [hideBanner, setHideBanner] = React.useState<boolean>(false)

  const handleDismiss = (): void => {
    setTimeout(() => {
      setHideBanner(true)
    }, 300)
  }

  if (hideBanner) return null

  return (
    <Box
      className='flex-v-align'
      sx={{
        backgroundColor: color,
        p: 2,
        width: '100%',
        justifyContent: 'center',
        position: 'relative',
        ...sx,
      }}
      gap={2}
    >
      <Box sx={{ textAlign: textAlign, display: 'flex', alignItems: 'center', gap: 1 }}>
        {startIcon && startIcon}
        {message}
      </Box>
      {dismissable && (
        <Box sx={{ position: 'absolute', right: 16 }}>
          <IconButton onClick={handleDismiss}>
            <CloseIcon />
          </IconButton>
        </Box>
      )}
    </Box>
  )
}

export default Banner
